import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import SelectMultiple from '@/components/_custom/Selector/selectMultiple/selectMultiple.tsx'
import SelectUnique from '@/components/_custom/Selector/selectUnique/selectUnique.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import Loading from '@/components/Loading/Loading.tsx'
import styles from './mealChildSettings.module.scss'
import { useMealChildSettings } from './useMealChildSettings'
import { useDialog } from '@/hooks/useDialog/useDialog'
import DaycareMeal from '@/container/daycare/daycareProfile/meal/meal'

interface MealChildSettingsProps {
    childId: number
}

const MealChildSettings: FunctionComponent<MealChildSettingsProps> = ({ childId }) => {
    const { t } = useTranslation()
    const {
        loading,
        selectedMealMenu,
        setSelectedMealMenu,
        selectedMealTexture,
        setSelectedMealTexture,
        selectedMealHabit,
        setSelectedMealHabit,
        optionsMealMenu,
        optionsMealTexture,
        optionsMealHabit,
        canEditMeal,
        hasChanges,
        updateDaycareChildMeal,
        refetchMealMenus,
        refetchMealTextures,
        refetchMealHabits
    } = useMealChildSettings(childId)

    const { dialog, openDialogActionItem, reopenTrigger } = useDialog({
        dialogTitle: 'mealSettings',
        Component: DaycareMeal,
        props: () => ({ hideShowMeal: true }),
        resourceLabel: { type: 'manageResource', label: 'mealSettings' }
    })

    if (loading) return <Loading overall={false} />

    return (
        <div className={styles.Container}>
            <div className={styles.SelectContainer}>
                <SelectUnique
                    selectOptions={optionsMealMenu}
                    selectValue={selectedMealMenu}
                    setSelectValue={setSelectedMealMenu}
                    label={t('myMenu')}
                    className={styles.UserInput}
                    readOnly={!canEditMeal}
                    onOpen={() => void refetchMealMenus()}
                    actionItem={openDialogActionItem}
                    reopenTrigger={reopenTrigger}
                />
                <SelectMultiple
                    selectOptions={optionsMealTexture}
                    selectValues={selectedMealTexture}
                    setSelectValues={setSelectedMealTexture}
                    label={t('myMealTextures')}
                    className={styles.UserInput}
                    readOnly={!canEditMeal}
                    onOpen={() => void refetchMealTextures()}
                    actionItem={openDialogActionItem}
                    reopenTrigger={reopenTrigger}
                />
            </div>
            <div className={styles.SelectContainer}>
                <SelectMultiple
                    selectOptions={optionsMealHabit}
                    selectValues={selectedMealHabit}
                    setSelectValues={setSelectedMealHabit}
                    label={t('myMealHabits')}
                    className={styles.UserInput}
                    readOnly={!canEditMeal}
                    onOpen={() => void refetchMealHabits()}
                    actionItem={openDialogActionItem}
                    reopenTrigger={reopenTrigger}
                />
            </div>
            {canEditMeal && (
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'update'}
                        onClick={updateDaycareChildMeal}
                        className={styles.Button}
                        disabled={!hasChanges}
                    />
                </div>
            )}
            {dialog}
        </div>
    )
}

export default MealChildSettings
